import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SessionActions } from '../session.actions';

@Injectable({
  providedIn: 'root',
})
export class SessionFacade {
  private readonly store = inject(Store);

  /**
   * Drops every feature slice. Call at any session boundary so no part of the
   * outgoing account's state is left for the next one to read.
   */
  public resetSessionState(): void {
    this.store.dispatch(SessionActions.ResetSessionState());
  }
}
